import Nullstack from 'nullstack';
export default function IconWhirl({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-whirl",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M14 12a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z"
  }), "   ", Nullstack.element("path", {
    d: "M12 21c-3.314 0 -6 -2.462 -6 -5.5s2.686 -5.5 6 -5.5"
  }), "   ", Nullstack.element("path", {
    d: "M21 12c0 3.314 -2.462 6 -5.5 6s-5.5 -2.686 -5.5 -6"
  }), "   ", Nullstack.element("path", {
    d: "M12 14c3.314 0 6 -2.462 6 -5.5s-2.686 -5.5 -6 -5.5"
  }), "   ", Nullstack.element("path", {
    d: "M14 12c0 -3.314 -2.462 -6 -5.5 -6s-5.5 2.686 -5.5 6"
  }), " ");
}